import { render, staticRenderFns } from "./CircleInvitePatient.vue?vue&type=template&id=39c84e1c&scoped=true"
import script from "./CircleInvitePatient.vue?vue&type=script&lang=js"
export * from "./CircleInvitePatient.vue?vue&type=script&lang=js"
import style0 from "./CircleInvitePatient.vue?vue&type=style&index=0&id=39c84e1c&prod&scoped=true&lang=css"
import style1 from "./CircleInvitePatient.vue?vue&type=style&index=1&id=39c84e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c84e1c",
  null
  
)

export default component.exports